import { useMutation } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'

type Props = {
  color: string
  statusId?: string
  name?: string
}

export function useUpdateStatusDetails() {
  return useMutation({
    mutationFn: async ({ statusId, color, name }: Props) => {
      const response = await axios.put(`workflow-statuses/${statusId}`, {
        name,
        color,
      })
      return response.data
    },
  })
}
